import React, { useState, useEffect } from 'react'
import styles from './DiaryResult.module.css'

const DiaryResult = ({ diaryData, onNavigateToDiary }) => {
  const [aiResponse, setAiResponse] = useState(null)

  // 감정에 따른 메시지 (이미지는 API에서 제공)
  const generateAIResponse = (emotion, content) => {
    const aiResponses = {
      happy: {
        message: '행복한 순간들이 모여 아름다운 하루가 되었네요. 오늘의 기쁨이 내일의 힘이 됩니다!',
      },
      excited: {
        message: '새로운 시작에 대한 설렘이 느껴져요. 기대하는 마음으로 내일을 맞이해보세요!',
      },
      love: {
        message: '사랑하는 마음은 세상을 아름답게 만듭니다. 그 마음을 계속 간직하세요.',
      },
      calm: {
        message: '평온함 속에서 진정한 나를 만날 수 있어요. 이 고요함을 즐겨보세요.',
      },
      anxious: {
        message: '걱정은 내일의 힘을 빼앗아갑니다. 깊은 숨을 쉬고, 한 걸음씩 나아가세요.',
      },
      proud: {
        message: '스스로를 자랑스럽게 여기는 것은 성장의 증거입니다. 당신은 충분히 잘하고 있어요!',
      },
      tired: {
        message: '피곤한 하루였군요. 충분히 쉬면서 자신을 돌봐주세요. 내일은 더 나은 날이 될 거예요.',
      },
      sad: {
        message: '슬픔도 소중한 감정이에요. 이 감정을 느끼고 받아들이는 당신이 강하답니다.',
      },
      lonely: {
        message: '혼자라는 느낌이 들 때, 자신과 깊이 대화할 수 있는 시간이기도 해요.',
      },
      angry: {
        message: '화가 나는 것도 괜찮아요. 감정을 표현하고 천천히 진정해보세요.',
      },
      confused: {
        message: '혼란스러울 때는 한 발짝 물러서서 생각해보세요. 답은 가까이에 있을 거예요.',
      },
      depressed: {
        message: '우울한 마음도 언젠가는 지나갑니다. 작은 것에서 위안을 찾아보세요.',
      }
    }

    return aiResponses[emotion.id] || aiResponses.happy
  }

  const emotionColors = {
    happy: '#FF6B9D',
    excited: '#8B6914',
    love: '#B8405E',
    calm: '#5F7161',
    anxious: '#8B8B4F',
    proud: '#5B8BA8',
    tired: '#4A5568',
    sad: '#4682B4',
    lonely: '#9CA3AF',
    angry: '#654321',
    confused: '#607D8B',
    depressed: '#8B5A8B'
  }

  useEffect(() => {
    if (!diaryData) {
      return
    }

    const baseResponse = generateAIResponse(diaryData.emotion, diaryData.content)
    setAiResponse(baseResponse)
  }, [diaryData])

  const backgroundColor = diaryData ? emotionColors[diaryData.emotion.id] : '#667eea'

  return (
    <div className={styles.container} style={{ background: backgroundColor }}>

      <div className={styles.content}>
        <div className={styles.dateSection}>
          <div className={styles.dateMain}>
            {new Date(diaryData.date).toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }).replace(/\. /g, '. ').slice(0, -1)}
          </div>
          <div className={styles.emotionTags}>
            <span className={styles.emotionTag}>#{diaryData.emotion.label}</span>
          </div>
        </div>

        <div className={styles.aiImageSection}>
          <div className={styles.imageWrapper}>
            <img src={diaryData.imageUrl} alt="AI Generated" className={styles.aiImage} />
          </div>
        </div>

        {aiResponse && (
        <div className={styles.messageSection}>
          <div className={styles.aiMessage}>
            {aiResponse.message}
          </div>
          </div>
        )}

        <div className={styles.diaryContent}>
          <h3 className={styles.contentTitle}>{diaryData.title}</h3>
          <p>{diaryData.content}</p>
        </div>

        <div className={styles.buttonGroup}>
          <button className={styles.listButton} onClick={onNavigateToDiary}>
            <i className="fas fa-list"></i>
            <span>목록으로</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DiaryResult
